class Api {
    
    public static URL_PREFIX = process.env.REACT_APP_URL_PREFIX;
    // public static URL_PREFIX = "http://localhost:28081";
    public static CODE_OK = "0";
}

export default Api;
